<template>
    <i-frame-panel v-bind:targetUrl="targetUrl" />
</template>

<script>
import iFramePanel from '@/components/iFramePanel'

export default {
  name: this.$route.params.id,
  components: {
     iFramePanel
  },
  data () {
    return {
       targetUrl: this.$route.params.id+'.html'
    }
  },
    mounted()
    {
        window.scroll({
            top:0,
            left:0,
            behavior:'smooth'
        });
    }


}
</script>
